require('./ctxInput.style.scss');
require('./../../sharedStyles/ctxInputTooltip.style.scss');

class CtxInputController {
    constructor($scope, $element, $filter, $attrs, $timeout) {
        this.$scope = $scope;
        this.$element = $element;
        this.transFilter = $filter('translate');
        this.$attrs = $attrs;
        this.$timeout = $timeout;
        this.$timeout(() => (this.id = $attrs.eventId), 0, false);
        this.hasFeedback = this.hasFeedback || false;
        this.inputDefaultType = this.inputType || 'text';
        this.numberMessageInfo = this.numberMessage || this.transFilter('ctxInput.validation.number.error');
        this.tooltipPosition = this.tooltipPosition || 'right';
        this.trimInput = this.trimInput || true;
    }

    $onInit() {
        this.lblOptional = angular.isUndefined(this.$attrs.isNotOptional)
            ? this.transFilter('common.form.default.label.optional')
            : '';
        if (this.showPassword) {
            this.hasFeedback = true;
            this.faIcon = 'icon-eye';
            this.$timeout(() => {
                this.$element.find('.form-control-feedback').on('mousedown', (event) => {
                    event.preventDefault();
                    this.$element.find('input').attr('type', 'text');
                    this.$element.find('.form-control-feedback').removeClass('icon-eye');
                    this.$element.find('.form-control-feedback').addClass('icon-eye-off');
                });
                this.$element.find('.form-control-feedback').on('mouseup', (event) => {
                    event.preventDefault();
                    this.$element.find('input').attr('type', 'password');
                    this.$element.find('.form-control-feedback').addClass('icon-eye');
                    this.$element.find('.form-control-feedback').removeClass('icon-eye-off');
                });
            }, 0);
        }

        if (this.validateCustom && this.form) {
            this.$scope.$watch(
                () => this.inputValue,
                (value) => {
                    this.form[this.inputName].$setValidity('custom', this.validateCustom({ value: value }));
                }
            );
            this.$scope.$watch(
                () => this.customValidationCounter,
                (value) => {
                    if (!this.customValidationCounter) return;
                    this.form[this.inputName].$setValidity('custom', this.validateCustom({ value: value }));
                }
            );
            this.$scope.$watch(
                () => this.isDisabled,
                () => {
                    if (!this.isDisabled)
                        this.form[this.inputName].$setValidity(
                            'custom',
                            this.validateCustom({ value: this.inputValue })
                        );
                    else this.form[this.inputName].$setValidity('custom', true);
                }
            );
        }
        if (this.isDatepickerMode) {
            let input = this.$element.find('input'),
                defaultValues = {
                    locale: 'en',
                    format: 'MM/DD/YYYY HH:mm:ss',
                    widgetPositioning: { horizontal: 'left', vertical: 'top' },
                    showClear: true,
                },
                locale =
                    this.datePickerOptions && this.datePickerOptions.locale
                        ? this.datePickerOptions.locale
                        : defaultValues.locale,
                format =
                    this.datePickerOptions && this.datePickerOptions.format
                        ? this.datePickerOptions.format
                        : defaultValues.format;

            moment.locale(locale);
            this.$scope.$watch(
                () => input.val(),
                (val) => {
                    if (typeof val === 'undefined') {
                        return;
                    }
                    this.inputValue = val;
                    this.milisecValue = moment(this.inputValue, format).isValid()
                        ? moment(this.inputValue, format).valueOf()
                        : null;
                }
            );
            input.datetimepicker(this.datePickerOptions ? this.datePickerOptions : defaultValues);
            input.on('dp.change', (event) => {
                this.setDatePickerValue(input.val(), format);
                if (this.datePickerFunctions && this.datePickerFunctions.onChange)
                    this.datePickerFunctions.onChange({ event: event, picker: input.data('DateTimePicker') });
            });

            if (this.datePickerFunctions) {
                // INFO: MIN and MAX DATE value should be set on parent level inside onShow function
                if (this.datePickerFunctions.onShow) {
                    input.on('dp.show', (event) => {
                        this.datePickerFunctions.onShow({ event: event, picker: input.data('DateTimePicker') });
                    });
                }
                if (this.datePickerFunctions.onHide) {
                    input.on('dp.hide', (event) => {
                        this.datePickerFunctions.onHide({ event: event, picker: input.data('DateTimePicker') });
                    });
                }
                if (this.datePickerFunctions.onChange) {
                    input.on('dp.change', (event) => {
                        this.datePickerFunctions.onChange({ event: event, picker: input.data('DateTimePicker') });
                    });
                }
                if (this.datePickerFunctions.onError) {
                    input.on('dp.error', (event) => {
                        this.datePickerFunctions.onError({ event: event, picker: input.data('DateTimePicker') });
                    });
                }
            }
        }

        this.$scope.$watch(
            () => this.numberMessage,
            (numberMessage) => {
                if (!numberMessage) return;
                this.numberMessageInfo = this.numberMessage;
            }
        );

        if (angular.isDefined(this.bindToSwitch)) {
            this.$scope.$watch(
                () => this.bindToSwitch,
                (switchValue) => {
                    if (!switchValue) this.inputValue = '';
                }
            );
        }
    }

    setDatePickerValue(val, format) {
        if (typeof val === 'undefined' || this.inputValue === val) {
            return;
        }
        this.inputValue = val;
        this.milisecValue = moment(this.inputValue, format).isValid()
            ? moment(this.inputValue, format).valueOf()
            : null;
    }

    $postLink() {
        this.requiredMessage =
            this.requiredMessage || this.transFilter('common.form.default.input.validation.required');
    }

    isTouched() {
        return this.form && this.form[this.inputName].$touched;
    }

    isUntouched() {
        return this.form && this.form[this.inputName].$dirty && !this.form[this.inputName].$touched;
    }

    isFormSubmitted() {
        return this.form && this.form.$submitted;
    }

    isTouchedOrSubmitted() {
        return this.isFormSubmitted() || this.isTouched();
    }

    hasErrorsFlags() {
        return (
            this.form[this.inputName].$error.required ||
            this.form[this.inputName].$error.url ||
            this.form[this.inputName].$error.custom ||
            this.form[this.inputName].$error.minlength ||
            this.form[this.inputName].$error.maxlength ||
            this.form[this.inputName].$error.min ||
            this.form[this.inputName].$error.max ||
            this.form[this.inputName].$error.number ||
            this.form[this.inputName].$error.pattern
        );
    }

    hasErrors() {
        return (this.untouchedError || this.isTouchedOrSubmitted()) && this.hasErrorsFlags();
    }

    isValid() {
        if (angular.isUndefined(this.form)) return;
        return this.form[this.inputName].$dirty && this.form[this.inputName].$valid;
    }

    clearValue() {
        this.inputValue = '';
        //If the color of the control is green, set it back to default
        this.form[this.inputName].$setPristine();
    }
}

CtxInputController.$inject = ['$scope', '$element', '$filter', '$attrs', '$timeout'];

const ctxInputComponent = {
    restrict: 'E',
    controller: CtxInputController,
    require: ['ngModel'],
    scope: {},
    template: require('./ctxInput.template.html'),
    bindings: {
        form: '<',
        inputName: '@',
        hasFeedback: '<?',
        inputLabel: '@?',
        formClass: '@?',
        inputClass: '@?',
        inputType: '@?',
        placeholder: '@?',
        inputValue: '=',
        milisecValue: '=?',
        onChange: '&?',
        faIcon: '@?',
        isRequired: '<?',
        isDisabled: '<?',
        isReadOnly: '<?',
        maxLength: '@?',
        minLength: '@?',
        validatePattern: '=?',
        patternMessage: '@?',
        requiredMessage: '@?',
        urlMessage: '@?',
        validateCustom: '&?',
        customValidationCounter: '<?',
        customMessage: '@?',
        maxNumberValue: '<?',
        minNumberValue: '<?',
        numberMessage: '<?',
        tooltipPosition: '@?',
        isDatepickerMode: '<?',
        datePickerOptions: '<?',
        datePickerFunctions: '<?',
        iconTooltip: '@',
        iconTooltipText: '@',
        overflowTooltip: '<?',
        untouchedError: '<?',
        showPassword: '<?',
        bindToSwitch: '=?',
        skipDisabled: '<?',
        trimInput: '<?',
        predefinedPlaceholder: '<?',
        inlineText: '@?',
        showClear: '<?',
    },
};

module.exports = ctxInputComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxInput/ctxInput.component.js